import * as React from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import { bindActionCreators } from "redux";
import {
    Grid,
    Button,
    TextField,
    FormControl,
    IconButton,
    Box,
    Typography,
    Modal,
    Select,
    MenuItem,
    InputLabel,
} from '@mui/material';
import SuccessImage from "../../../../assests/images/success.png"

import { useEffect } from 'react';
import { toast } from 'react-toastify';
import {updateUserRole} from '../actions/administration';
import { useState } from 'react';
import { getuser } from '../../dashboard/actions/dashboardAction' 
import { connect } from 'react-redux';

const ChangeRoleModal = ({ open, handleClose, SaveModal, saveModalOpen, userData,getuser }) => {
    const [role, setRole] = useState(null);
    const onSubmit1 = () => {
        const userDetails = window.sessionStorage.getItem('userDetails') ? JSON.parse(window.sessionStorage.getItem('userDetails')) : null
        const inputObject = {
            accountid: userDetails ? userDetails.accountId : null,
            roleid: role,
            user_id: userData.userid
        }
        updateUserRole(inputObject,(error, result)=>{
            if(result && result.success){
                saveModalOpen(true);
                if(userDetails.userId === userData.userid){
                    getuser(userDetails.userId);
                    setTimeout(()=>{
                        window.location.reload()
                    },2000)
                }
            }else{
                toast("Error in sending invite to user", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                    position: toast.POSITION.BOTTOM_CENTER,
                  });
            }
        })
      }

      
      useEffect(()=>{
        if(userData){
            setRole(userData.roleid)
        }
      },[userData])
    return (
        <div>

            <Modal
                open={open}
                onClose={() => handleClose()}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    width: '30%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    border: '0px solid #000',

                }}
                >

                    <Grid sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row', borderBottom: '1px solid #e0e0e0', paddingBottom: '15px' }}>
                        <Grid>
                            <Typography variant="h6" component="h6" sx={{ mt: 1, ml: 2 }}>Change Role</Typography>
                        </Grid>
                        <Grid >
                            <IconButton onClick={() => handleClose()} >
                                <ClearIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                    <Grid sx={{ display: 'flex', flexDirection: 'column', p: '20px 35px 10px 35px' }}>



                        <FormControl variant="standard" className='formControl' >
                            <InputLabel id="demo-simple-select-standard-label">Role</InputLabel>
                            <Select
                                style={{ color: "black", marginBottom: '10px' }}
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-standard"
                                label="Role"
                                value={role}
                                onChange={(e)=>{setRole(e.target.value)}}
                            >
                                <MenuItem value="2">Administrator</MenuItem>
                                <MenuItem value="7">Back Office Viewer</MenuItem>
                                <MenuItem value="8">Sales Personnel Viewer</MenuItem>
                                <MenuItem value="9">Data Entry Assistant</MenuItem>
                                <MenuItem value="10">Sales Personnel Admin</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Box sx={{
                        pt: 1, pl: 2, pr: 4, pb: 4
                    }}
                    >

                        <Grid sx={{ display: 'flex', flexDirection: 'row', mt: 2, justifyContent: 'space-evenly', justifyItems: 'flex-end' }}>
                            <Grid >
                                <Button variant="text" sx={{ width: '6rem' }} className='customButton' onClick={() => handleClose()} >
                                    Cancel
                                </Button>
                            </Grid>
                            <Grid>
                                <Button variant="text" sx={{ width: '6rem' }} className='customButton' onClick={() => onSubmit1()} >
                                    Save
                                </Button>

                            </Grid>

                        </Grid>
                    </Box>
                </Box>
            </Modal>

            {SaveModal ?
                <Modal
                    open={SaveModal}
                    onClose={() => handleClose()}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        width: '40%',
                        height: '50%',
                        transform: 'translate(-50%, -50%)',
                        bgcolor: 'background.paper',
                        border: '0px solid #000',

                    }}
                    >

                        <Grid sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row', float: 'right' }}>
                            <Grid>
                                <IconButton onClick={() => handleClose()} >
                                    <ClearIcon />
                                </IconButton>
                            </Grid>
                        </Grid>
                        <Grid sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', mt: '6rem' }}>
                            <Grid >
                                <img src={SuccessImage} sx={{ width: '30%', height: '30%' }}></img>
                            </Grid>
                            <Grid>
                                <Typography variant="h6" component="h2">Role changed Successfully</Typography>
                            </Grid>
                        </Grid>

                    </Box>
                </Modal>

                : null}
        </div>
    );
}


function mapStateToProps({}) {
    return {
    };
  }
  
  function mapDispatchToProps(dispatch) {
    return bindActionCreators(
      {
        getuser,
      },
      dispatch
    );
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(ChangeRoleModal);
  